import { useContext } from "react";
import { useParams } from "react-router";
import { ReportContext } from "../context";
const useGetFileAndReportId = () => {
    const { fileId } = useParams();
    const { reportId } = useContext(ReportContext);
    return { reportId, fileId };
};
export { useGetFileAndReportId };
//# sourceMappingURL=useGetFileAndReportId.js.map